<script>
  import Card from "./Card.svelte";
  import PureSwiper from "../PureSwiper.svelte";
  export let activityProducts = [];
</script>

<PureSwiper items={activityProducts} component={Card} on:click />
